export const workflowStages = [
  { id: 'analysis', label: '原文分析', tip: '读懂原文与人物关系，核对提取依据。' },
  { id: 'plan', label: '拆集方案', tip: '确认每集内容、冲突和承接，再继续人物设计。' },
  {
    id: 'design',
    label: '角色与画风',
    tip: '确认人物设定、统一画风；到角色库确认参考图和所需配音音色。',
  },
  { id: 'script', label: '剧本与分镜', tip: '核对逐镜动作、完整台词、听话人和时间安排。' },
  { id: 'keyframes', label: '关键帧', tip: '逐镜确认人物、道具和构图，批准后再生成视频。' },
  { id: 'media', label: '画面与配音', tip: '播放每个镜头和对白，处理失败项，再批准素材进入合成。' },
  {
    id: 'render',
    label: '成片审阅',
    tip: '完整观看合成预览，确认字幕、声音与下集交接，再定稿本集。',
  },
];

export function StageGuide({
  stage,
  state,
  paused = false,
  visualMode,
  episodeNumber,
  selectStage,
}: {
  stage: string;
  state: string;
  paused?: boolean;
  visualMode?: string;
  episodeNumber?: number;
  selectStage?: ((stage: string) => void) | undefined;
}) {
  const current = workflowStages.findIndex((item) => item.id === stage);
  const details = workflowStages[current];
  return (
    <section className="stage-guide" aria-label="本集制作阶段">
      <div className="novel-stepper">
        {workflowStages.map((item, index) => {
          const skipped = item.id === 'keyframes' && visualMode === 'image';
          const allowed = !skipped && (index <= current || state === 'completed');
          return (
            <button
              key={item.id}
              type="button"
              aria-current={item.id === stage ? 'step' : undefined}
              className={`${item.id === stage ? 'active' : ''} ${index < current ? 'done' : ''}`}
              disabled={!selectStage || !allowed}
              onClick={() => selectStage?.(item.id)}
            >
              <span>{index + 1}</span>
              {item.label}
              {skipped ? '（不适用）' : ''}
            </button>
          );
        })}
      </div>
      <div className="stage-guidance" role="status">
        <strong>
          {episodeNumber ? `第 ${episodeNumber} 集 · ` : ''}
          {state === 'completed'
            ? '本流程已完成'
            : `${details?.label ?? '当前阶段'} · ${paused ? '已暂停' : state === 'failed' ? '需处理' : state === 'review' ? '等你审批' : '进行中'}`}
        </strong>
        <p>
          {state === 'completed'
            ? '可下载已定稿成片，或查看各阶段的历史版本。'
            : state === 'failed'
              ? '先处理当前错误。已成功的素材保留，恢复与生成新候选是不同操作，请按按钮说明选择。'
              : details?.tip}
        </p>
        {paused && <small>恢复流程后才安排下一步；已提交的任务会保留结果。</small>}
      </div>
    </section>
  );
}
